import React from 'react';
import { Title, Text, Paper, TextInput, Table, Button, Avatar, Badge, Group } from '@mantine/core';
import { Tag, Search, Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function ListsPage() {
  const navigate = useNavigate();
  const lists = [{
    id: 1,
    name: 'Deputados',
    contactCount: 45,
    description: 'Lista de deputados estaduais',
    lastUpdate: 'Hoje, 11:30'
  }, {
    id: 2,
    name: 'Vereadores',
    contactCount: 78,
    description: 'Lista de vereadores municipais',
    lastUpdate: 'Ontem, 15:45'
  }, {
    id: 3,
    name: 'Suplentes',
    contactCount: 32,
    description: 'Lista de suplentes',
    lastUpdate: '22/05/2023, 14:20'
  }, {
    id: 4,
    name: 'Coordenadores',
    contactCount: 25,
    description: 'Lista de coordenadores regionais',
    lastUpdate: '20/05/2023, 09:15'
  }, {
    id: 5,
    name: 'Diretório Municipal',
    contactCount: 150,
    description: 'Membros do diretório municipal',
    lastUpdate: '19/05/2023, 16:40'
  }];
  return <div className="space-y-6" data-id="element-468">
      <div className="flex justify-between items-center" data-id="element-469">
        <div data-id="element-470">
          <Title order={2} className="text-primary" data-id="element-471">
            Listas de Contatos
          </Title>
          <Text c="dimmed" data-id="element-472">Gerencie suas listas de contatos</Text>
        </div>
        <Button leftSection={<Plus size={18} data-id="element-474" />} radius="lg" styles={{
        root: {
          backgroundColor: '#0047AB',
          height: '48px',
          '&:hover': {
            backgroundColor: '#003d91'
          }
        }
      }} data-id="element-473">
          Nova Lista
        </Button>
      </div>
      <Paper radius="lg" p="md" withBorder data-id="element-475">
        <Group justify="space-between" mb="md" data-id="element-476">
          <TextInput placeholder="Buscar listas..." leftSection={<Search size={18} data-id="element-478" />} className="w-full max-w-md" data-id="element-477" />
        </Group>
        <Table highlightOnHover data-id="element-479">
          <Table.Thead data-id="element-480">
            <Table.Tr data-id="element-481">
              <Table.Th data-id="element-482">Nome</Table.Th>
              <Table.Th data-id="element-483">Descrição</Table.Th>
              <Table.Th data-id="element-484">Contatos</Table.Th>
              <Table.Th data-id="element-485">Última Atualização</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody data-id="element-486">
            {lists.map(list => <Table.Tr key={list.id} className="cursor-pointer hover:bg-gray-50" onClick={() => navigate(`/lists/${list.id}`)} data-id="element-487">
                <Table.Td data-id="element-488">
                  <Group data-id="element-489">
                    <Avatar radius="xl" style={{
                  backgroundColor: '#E3F2FD',
                  color: '#003d91'
                }} data-id="element-490">
                      <Tag size={18} data-id="element-491" />
                    </Avatar>
                    <Text fw={500} data-id="element-492">{list.name}</Text>
                  </Group>
                </Table.Td>
                <Table.Td data-id="element-493">
                  <Text size="sm" c="dimmed" data-id="element-494">
                    {list.description}
                  </Text>
                </Table.Td>
                <Table.Td data-id="element-495">
                  <Badge color="blue" variant="light" data-id="element-496">
                    {list.contactCount} contatos
                  </Badge>
                </Table.Td>
                <Table.Td data-id="element-497">
                  <Text size="sm" c="dimmed" data-id="element-498">
                    {list.lastUpdate}
                  </Text>
                </Table.Td>
              </Table.Tr>)}
          </Table.Tbody>
        </Table>
      </Paper>
    </div>;
}